import { mainAxiosInstance } from "../../../../../services/service";
import { vehicleHealthCheckEndpoints } from "../../../../../services/service-constants";

export const getVibrationalPerformanceData = async (payload) => {
  const url = `${vehicleHealthCheckEndpoints.get_performance}`;
  
  //   TODO : dynamic vin_number and org_id required
  const requestBody = {
    vinNumber: payload.vinNumber,
    organizationId: 1,
    profile: "Engine",
    parts: ["Combustion", "Crankshaft"],
  };
  return mainAxiosInstance
    .post(url, requestBody)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch((err) => {
      Promise.reject();
    });
};
